<template>
  <div id="app">
    <Header></Header>
    <transition name="fade">
      <router-view></router-view>
    </transition>

    <!-- 页面为login和home的时候显示下面的组件 -->
    <!-- <transition-group name="fade" v-if="$route.path == '/login' || $route.path == '/home' || $route.path == '/homeDetail' || $route.path == '/product-aggregation-page'"> -->
    <transition-group name="fade">
      <Footer key="footer" v-if="$route.path == '/login' || $route.path == '/home' || $route.path == '/homeDetail' || $route.path == '/product-aggregation-page'"></Footer>
      <Footer1 key="footer1" v-else></Footer1>
      <Tool key="tool"></Tool>
    </transition-group>
  </div>
</template>

<script>
import Header from "./components/Header.vue";
import Footer from "./components/Footer.vue";
import Footer1 from "./components/Footer-1.vue";
import Tool from "./components/Tool.vue";
export default {
  name: "App",
  components: {
    Header,
    Footer,
    Footer1,
    Tool,
  },
  created() {},
  methods: {},
};
</script>

<style>
@font-face {
  font-family: "Georgia-Bold";
  src: url("assets/css/Georgia-Bold.woff") format("woff"),
    url("assets/css/Georgia-Bold.otf") format("opentype");
  /* 添加其他字体格式，如woff2, ttf等 */
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
